<template>
  <transition name="toast-fade">
    <div v-if="isVisible" :class="['toast', type]">
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  name: "ToastNotification",
  props: {
    message: { type: String, required: true },
    type: { type: String, default: "info" },
    duration: { type: Number, default: 3000 },
  },
  data() {
    return {
      isVisible: false,
      timeout: null,
    };
  },
  methods: {
    show() {
      // Reinicia a visibilidade para forçar re-render
      this.isVisible = false;
      this.$nextTick(() => {
        this.isVisible = true;
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.hide(), this.duration);
      });
    },
    hide() {
      this.isVisible = false;
    },
  },
};
</script>

<style scoped>
.toast {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 20px;
  border-radius: 5px;
  color: white;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  min-width: 250px;
}
.toast.success {
  background-color: #4caf50;
}
.toast.error {
  background-color: #f44336;
}
.toast.warning {
  background-color: #ff9800;
}
.toast.info {
  background-color: #2196f3;
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.5s ease;
}
.toast-fade-enter,
.toast-fade-leave-to {
  opacity: 0;
}
</style>
